import type { CursorConfigResponse, CursorSetupResponse } from '../types/api'
import { apiClient } from './client'

export async function getCursorConfig(): Promise<CursorConfigResponse> {
  return apiClient.get<CursorConfigResponse>('/cursor/config')
}

/** @lintignore — reserved for upcoming Cursor setup UI; getCursorConfig is the current entry */
export async function setupCursor(projectId?: number): Promise<CursorSetupResponse> {
  const query = projectId !== undefined ? `?projectId=${projectId}` : ''
  return apiClient.post<CursorSetupResponse>(`/cursor/setup${query}`)
}
